import { useEffect, useState } from "react";
import { ShieldOff } from "lucide-react";
import { api } from "@/lib/api";

export function AccessBlockedPage() {
  return (
    <div className="min-h-screen bg-[#F7F8FA] flex items-center justify-center px-6" data-testid="access-blocked-page">
      <div className="max-w-md text-center">
        <ShieldOff className="w-10 h-10 text-slate-400 mx-auto" />
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Access not available</h1>
        <p className="mt-2 text-sm text-slate-500">This service is not available right now.</p>
      </div>
    </div>
  );
}

// Listens for blocked API responses anywhere in the app.
export function AccessBlockListener({ children }) {
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    const on = () => setBlocked(true);
    window.addEventListener("access-blocked", on);
    return () => window.removeEventListener("access-blocked", on);
  }, []);
  return blocked ? <AccessBlockedPage /> : children;
}

// Pre-checks a scope on page load (public pages, Branch/Merchant login).
export function AccessGate({ scope, children }) {
  useEffect(() => { api.get("/access/check", { params: { scope } }).catch(() => {}); }, [scope]);
  return children;
}
